import React, { useEffect, useState,Fragment } from 'react'
import { Card, Col, Container, Form, Row } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import { useDispatch, useSelector } from 'react-redux'
import { formato_monto, formato_rut } from '../../../common/Formatos'
import { configuracionFormAction8,obtenerCasoImplicado,ObtenerCompanias,obtenerDetalles,obtenerRequisitos, ObtenerSeguros  } from '../../../store/actions/encargado-cia-action'
// import Requisitos from './Requisitos'


const AntededentesRecobroLegaliza = ({formik,setPorConvenioOld,setMirecobroNo}) => {
  const data_legalizacion =useSelector((state) => state.legalizacionPagoReducer)
  const {cfg_form10}=data_legalizacion
  const data_encargado_cia = useSelector((state) => state.encargado_compania)
  const { cfg_form9, casoImplicado, liquidacionPerdida, detalles, companias, requisitos, seguros , llaves} = data_encargado_cia
  const [seguro, setSeguro]=useState("")
  const [compania, setCompania]=useState("")
  const [siniestro, setSiniestro]=useState("")
  const [fechaSiniestro, setFechaSiniestro]=useState("")
  const [convenio, setConvenio]=useState(0)
  const [convenioOld, setConvenioOld]=useState(0)
  const[montoNeto,setMontoNeto]=useState(0)
  const[recobroNoFormato,setRecobroNoFormato]=useState(0)
  const[requisitosValida,setRequisitos]=useState("")

  const [miRecobro, setMiRecobro]=useState(0)
  const [miMontoNeto, setMiMontoNeto]=useState(0)
  
  const dispatch = useDispatch();


 useEffect(() => {
   setMiMontoNeto(casoImplicado && casoImplicado.length !== 'undefined'
   ? casoImplicado.casoImplicado[0]['MontoCosto']
   : "")
   setMiRecobro(casoImplicado && casoImplicado.length !== 'undefined'
   ? formato_monto(casoImplicado.casoImplicado[0]['MontoRecobro'])
   : "")
   setRecobroNoFormato(casoImplicado && casoImplicado.length !== 'undefined'
   ? casoImplicado.casoImplicado[0]['MontoRecobro']
   : "")
 }, [casoImplicado]);

  useEffect(()=>{
    setRequisitos(requisitos && requisitos.requisitos)
  },[requisitos])
  useEffect(()=>{
    setMontoNeto(liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
    ? liquidacionPerdida.liquidacionPerdida['mtoSalvataje']!==null && liquidacionPerdida.liquidacionPerdida['mtoPago']!==null
      ? (parseInt(liquidacionPerdida.liquidacionPerdida['mtoPago']) - parseInt(liquidacionPerdida.liquidacionPerdida['mtoSalvataje'])) 
      :(liquidacionPerdida.liquidacionPerdida['mtoPago'])
    : 0)
  },[liquidacionPerdida])
useEffect(()=>{
  setSeguro(casoImplicado && casoImplicado.length !== 'undefined'
  ? casoImplicado.casoImplicado[0]['IdSeguroImplicado']
  : "")
  setCompania(casoImplicado && casoImplicado.length !== 'undefined'
  ?casoImplicado.casoImplicado[0]['IdCiaImplicado']!==null?casoImplicado.casoImplicado[0]['IdCiaImplicado']:""
  : "")
  setSiniestro( casoImplicado && casoImplicado.length !== 'undefined'
  ? (casoImplicado.casoImplicado[0]['SiniestroIM']===null?"":casoImplicado.casoImplicado[0]['SiniestroIM'])
  : "")
  setFechaSiniestro(casoImplicado && casoImplicado.length !== 'undefined'
  ? (casoImplicado.casoImplicado[0]['FechaSiniestroIM']===null?"":casoImplicado.casoImplicado[0]['FechaSiniestroIM'].split("T")[0])
  : "")
  setConvenio(casoImplicado && casoImplicado.casoImplicado[0]['PorConvenido'])
  setConvenioOld(convenio)
  

},[casoImplicado,liquidacionPerdida,montoNeto])


// useEffect(() => {
//   if (llaves){

//     let query = Buffer.from(JSON.stringify({"idCaso":llaves["idCaso"],"gestion":"CC"})).toString('base64');
//     dispatch(obtenerRequisitos(query));
//     }

// }, [dispatch, llaves]);
// useEffect(() => {
   
//     let query = Buffer.from(JSON.stringify({"concepto":" 234"})).toString('base64');
//     dispatch(obtenerDetalles(query));

// }, [dispatch]);

const restarFechas=(fechaInicio)=>{    
  const [dia, mes, ano]=fechaInicio.split("-")   
  const fechaFormat=[ano, mes,dia].join("-")     
  const tiempoTranscurrido = Date.now();
  const hoy = new Date(tiempoTranscurrido).getTime(); 
  var diff = hoy - new Date(fechaFormat).getTime();
  return parseInt(diff/(1000*60*60*24));
}
function validaNumeros(event){ 
  
  var e = event || window.event;
    var key = e.keyCode || e.which;

    if ( key === 110 || key === 190 || key === 188 || key === 107|| key === 109  ) {     
        
       e.preventDefault();     
    }  
    if(key==8 || key===46 || key===37 ||key===39) { // backspace.
      return true;
    } else if(key>=48 && key<=57) { // is a number.
      return true;
    }else if(key>=96 && key<=105) { // is a number.
      return true;
    } 
    else{ // other keys.
      e.preventDefault();   
    } 
  // code is the decimal ASCII representation of the pressed key.
 
  
}
function validaConvenio(event){ 
  
  var e = event || window.event;
    var key = e.keyCode || e.which;
    if ( key === 110 || key === 190 ) {     
        
     return true;     
   } 
    
    if(key==8 || key===46 || key===37 ||key===39) { // backspace.
      return true;
    } else if(key>=48 && key<=57) { // is a number.
      return true;
    }else if(key>=96 && key<=105) { // is a number.
      return true;
    } 
    else{ // other keys.
      e.preventDefault();   
    } 
  // code is the decimal ASCII representation of the pressed key.
 
  
}
  return (
      <>
    
      <style type='text/css'>
        {`
    .convenio {
      
      
      width: 80px;
      
    }
    
    `}
      </style>
    <Card className='mt-1 '>
      <Card.Header className='mt-0 mb-0' as='h6' style={{backgroundColor:"#4F517A", color:"#FFFFFF"}}>
        {cfg_form10 ? cfg_form10.cfg_form10['legalizarecobro-title-antecrecobro'] : ""}
      </Card.Header>
      <Container>
        {cfg_form9 ? (
          <div>
          <Row className='mb-3'>
          <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form9 &&
                      cfg_form9.cfg_form9['respuestarecobro-lbl-estadorec']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3'>
                  {casoImplicado && casoImplicado.length !== 'undefined'
                    ? casoImplicado.casoImplicado[0]['EstadoImplicado']
                    : ""}
                </Form.Text>
                </Col>
               
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-cmb-cia']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3'>
                  { casoImplicado && casoImplicado.length !== 'undefined'
                        ?casoImplicado.casoImplicado[0]['CiaImplicado']
                    : ""}
                </Form.Text>

                 
                 
                </Col>
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form9 &&
                        cfg_form9.cfg_form9['respuestarecobro-input-siniestroimpl']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3'>
                  { casoImplicado && casoImplicado.length !== 'undefined'
                 ? casoImplicado.casoImplicado[0]['SiniestroIM']
                 : ""}
                </Form.Text>
                 
                  
                </Col>
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form9 &&
                      cfg_form9.cfg_form9['respuestarecobro-input-fechasinimpl']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3'>
                  { casoImplicado && casoImplicado.length !== 'undefined'
                 ? casoImplicado.casoImplicado[0]['FechaSiniestroIMFormat']
                 : ""}
                </Form.Text>
                  
                </Col>
                <Col  >
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-cmb-motivoexcep']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3'>
                  { casoImplicado && casoImplicado.length !== 'undefined'
                        ?casoImplicado.casoImplicado[0]['GlosaMotivoExcepcion']
                    : ""}
                </Form.Text>
                {/* <Form.Select
                    className='mt-2'
                    aria-label='Default select example'
                    onChange={e=>{                    
                        formik.handleChange(e)
                       setExcepcion(e.target.value)
                        
                        }}
                    name='motivoExcepcion'
                   
                    value={formik.values.motivoExcepcion =excepcion          
                    }
                  ><option value="1">Seleccionar...</option>
                    {detalles && detalles.detalles.map(d=>(
                      <option key={d.id} value={d.id}>{d.nombre}</option>
                    ))}
                  </Form.Select> */}
              </Col>
              </Row>
            <Row>
            <Col >
            <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-lbl-fechaenviocarta']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
               
                {casoImplicado && casoImplicado.length !== 'undefined'
                    ? casoImplicado.casoImplicado[0]['FechaEnvioCartaCobroFormat']: ""}
                </Form.Text>
            </Col>
           
              <Col>
                <Form.Label
                  className='mb-0  mt-2'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form9 && cfg_form9.cfg_form9 ['respuestarecobro-cmb-moneda']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3'>
                  {casoImplicado && casoImplicado.length !== 'undefined'
                    ? casoImplicado.casoImplicado[0]['GlosaMonedaLocal']
                    : ""}
                </Form.Text>
               
                
              </Col>
              <Col>
                <Form.Label
                  className=' mb-0  mt-2'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-input-mtoneto']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3'>
                {formato_monto(miMontoNeto)}
                </Form.Text>
                
              </Col>
              

              <Col>
                <Form.Label
                  className='mb-0  mt-2'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-input-porcconvenio']}
                </Form.Label>
                <br />
               
                <Form.Text className='mb-3'>
                        {convenio}
                </Form.Text>
               
              </Col>
              <Col>
                <Form.Label
                  className='mb-0  mt-2'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}

                >
                  {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-input-mtorecobro']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3'>
                {miRecobro}
                </Form.Text>
               
              </Col>
             
              
            </Row>
            <Row >
            <Col md="4" ></Col>
           
           
            
             

             
              
            </Row>
            <Row className="mb-3" >
            
            
           
            
              
              <Col></Col>
              <Col></Col>
           

             
              
            </Row>
            
           
          </div>
        ) : ""}
      </Container>
    </Card>


    </>
  )
}

export default AntededentesRecobroLegaliza


